<template>
    <div>
        <div class="my-content">
            <div class="columns">
                <div class="column">
                    <h1 class="title is-5">ລາຍການໃບບິນຮັບເງິນ</h1>
                </div>
                <div class="column has-text-right">
                    <b-field label="">
                        <b-datepicker icon="calendar-month"
                                      placeholder="ຄົ້ນຫາຕາມວັນທີ່ຊື້"
                                      v-model="dates"
                                      range>
                        </b-datepicker>
                    </b-field>
                </div>
            </div>
            <table-skeleton :has-image="true" v-if="isLoading"/>
            <b-table v-if="!isLoading"
                     :data="invoices"
                     class="database-table"
                     striped
                     paginated
                     per-page="20"
                     :current-page.sync="currentPage"
                     :selected.sync="selectedInvoice"
                     :default-sort-direction="defaultSortDirection"
                     :sort-icon="sortIcon"
                     :sort-icon-size="sortIconSize"
                     default-sort="created"
                     ref="databaseTable">
                <b-table-column width="12%" label="ເລກທີໃບບິນ" sortable field="invoiceNumber" v-slot="props">
                    <p>{{ props.row.invoiceNumber }}</p>
                </b-table-column>
                <b-table-column label="ວັນທີຊື້" sortable field="created" v-slot="props">
                    <p>{{ props.row.created | formatDateTime }}</p>
                </b-table-column>
                <b-table-column label="ລາຍຄາລວມ" sortable field="total" v-slot="props">
                    <strong>{{ props.row.total | formatMoney }}</strong> ກີບ
                </b-table-column>
                <b-table-column width="15%" label="ຊ່ອງທາງການຊໍາລະ" sortable field="paymentMethod" v-slot="props">
                    <p>{{ props.row.paymentMethod }}</p>
                </b-table-column>
                <b-table-column width="10%" label="ເລກທີອ້າງອີງ" sortable field="referenceNumber" v-slot="props">
                    <p>{{ props.row.referenceNumber }}</p>
                </b-table-column>
                <b-table-column width="10%" class="has-text-centered" v-slot="props">
                    <b-button type="is-danger" size="is-small" tag="router-link"
                              :to="`/receipt/${props.row.invoiceNumber}`" icon-left="printer">ພິມ
                    </b-button>
                </b-table-column>
            </b-table>
        </div>
    </div>
</template>

<script>
    import {paymentsCollection} from "../firebase";
    import TableSkeleton from "../components/TableSkeleton";

    export default {
        name: "Invoices",
        components: {TableSkeleton},
        data() {
            return {
                isLoading: false,
                currentPage: 1,
                defaultSortDirection: 'desc',
                sortIcon: 'arrow-up',
                sortIconSize: 'is-small',
                dates: [],
                invoices: [],
                selectedInvoice: null
            }
        },
        mounted() {
            this.getInvoices()
        },
        firestore: {
            //invoices: paymentsCollection.orderBy('created', 'desc')
        },
        methods: {
            getInvoices() {
                this.isLoading = !this.isLoading;
                const fromDate = this.getFormatDate(this.dates[0]);
                const toDate = this.getFormatDate(this.dates[1]);
                paymentsCollection.where('created', '>=', fromDate + ' 00:00:00').where('created', '<=', toDate + ' 23:59:59').get()
                    .then(res => {
                        this.invoices = [];
                        res.forEach(docSnapshot => {
                            this.invoices.push(docSnapshot.data());
                        });
                        this.isLoading = !this.isLoading;
                    }).catch(err => {
                    this.isLoading = !this.isLoading;
                    console.log(err);
                    this.$swal('', err, 'error')
                })
            }
        },
        watch: {
            dates(val) {
                console.log(val);
                this.getInvoices()
            }
        }
    }
</script>

<style scoped>

</style>